import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-emerald-50 border-t border-emerald-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://static.readdy.ai/image/9d639ef6c9792709f408f68c264ec65c/402bb47b1b6fd7c4f36ade1bab6a66a4.jpeg"
                alt="NatureIQ"
                className="h-20 w-auto object-contain"
              />
            </Link>
            <p className="text-emerald-700 font-medium mb-2">Ancient Wisdom, Modern Science</p>
            <p className="text-gray-600 max-w-md">
              Plant-based, organic, and nutritional products committed to promoting wellness through 
              natural, sustainable, and scientifically validated solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-600 hover:text-emerald-600 cursor-pointer">Home</Link></li>
              <li><Link to="/about" className="text-gray-600 hover:text-emerald-600 cursor-pointer">About Us</Link></li>
              <li><Link to="/products" className="text-gray-600 hover:text-emerald-600 cursor-pointer">Products</Link></li>
              <li><Link to="/wellness-blog" className="text-gray-600 hover:text-emerald-600 cursor-pointer">Wellness Blog</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-emerald-600 cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Contact</h3>
            <div className="space-y-2 text-gray-600">
              <p className="flex items-start">
                <i className="ri-map-pin-line w-5 h-5 mr-2 mt-1 text-emerald-600 flex-shrink-0"></i>
                <span>A11 Prachi Residency, Opp Kapil Malhar, Baner Road, Baner, Pune, Maharashtra 411045</span>
              </p>
              <div className="flex space-x-3 mt-4">
                <a href="#" className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="#" className="w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center text-emerald-600 hover:bg-emerald-600 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-emerald-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 text-sm">
            © 2024 NatureIQ. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-emerald-600 text-sm cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
